module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/boxoffice-module/components/narrow-col-basket-item/narrow-col-basket-item.component.scss
// module id = ./src/app/modules/boxoffice-module/components/narrow-col-basket-item/narrow-col-basket-item.component.scss
// module chunks = 9